import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { ConversationMessage } from '../../../../../../../core/src/lib/interface/conversation.interface';
import { ConversationService } from '../../../../../../../core/src/lib/state/conversation.service';
import { DialogData, ResponseEvaluationDialogComponent } from '../response-evaluation-dialog.component';
import { firstValueFrom } from 'rxjs';
import { EvaluationSentiment, Event } from '@vendasta/conversation';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'inbox-evaluation-buttons',
  imports: [MatIcon, MatIconButton, TranslateModule, MatTooltip],
  templateUrl: './inbox-evaluation-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './inbox-evaluation-buttons.component.scss',
})
export class InboxEvaluationButtonsComponent {
  private readonly dialog = inject(MatDialog);
  private readonly conversationService = inject(ConversationService);
  readonly message = input.required<ConversationMessage | Event>();

  async openEvaluateModal(helpful: boolean, message: ConversationMessage | Event): Promise<void> {
    const data: DialogData = {
      helpful: helpful,
    };
    const modalRef$ = this.dialog.open(ResponseEvaluationDialogComponent, {
      data: data,
      width: '660px',
    });
    const submission = await firstValueFrom(modalRef$.afterClosed());
    if (submission) {
      const sentiment = helpful
        ? EvaluationSentiment.EVALUATION_SENTIMENT_POSITIVE
        : EvaluationSentiment.EVALUATION_SENTIMENT_NEGATIVE;

      if (message instanceof Event) {
        await this.conversationService.evaluateResponse(
          submission?.comment,
          sentiment,
          '',
          message.eventId,
          message.conversationId,
        );
      } else {
        await this.conversationService.evaluateResponse(submission?.comment, sentiment, message.messageId!);
      }
    }
  }
}
